export const TutorialGifNotificationSlider = {
  // Was missing `extends: 'Navbar'` (unlike TutorialNotification /
  // TutorialGifNotification) — a real gap, not intentional: this card had
  // no `round:` at all and rendered square corners while every other card
  // in the family is `radiusControl`. Explicit `align`/`padding` below
  // override Navbar's row/inset defaults so nothing is silently inherited.
  extends: 'Navbar',
  theme: 'canvas-card-glass',
  padding: '0',
  overflow: 'hidden',
  align: 'stretch',
  round: 'radiusControl',
  useCookie: true,
  if: (el, s) => {
    const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true'
    return el.useCookie ? !preventByCookie : true
  },
  state: {
    slides: [
      {
        title: 'learn.coach.canvas.title',
        descr: 'learn.coach.canvas.descr',
        src: 'intro.gif',
        docsArticle: '/canvas-and-editor'
      },
      {
        title: 'learn.coach.realtime.title',
        descr: 'learn.coach.realtime.descr',
        src: 'realtime.gif',
        docsArticle: '/publish'
      },
      {
        title: 'learn.coach.edit.title',
        descr: 'learn.coach.edit.descr',
        src: 'editor.gif',
        docsArticle: '/building-in-symbols'
      }
    ],
    activeIndex: 0,
    key: 'codeTour'
  },
  Flex: {
    childExtends: 'TutorialPillsNotification',
    childrenAs: 'state',
    children: (el, s) => s.slides,
    childProps: {
      widthRange: '100%'
    },
    transition: 'C1 defaultBezier transform',
    onBeforeUpdate: (_, el, s) => {
      el.set({ transform: `translate3d(-${s.activeIndex * 100}%, 0, 1px)` })
    }
  },
  NavigationDots: {},
  TutorialNotificationButtons: {
    children: () => [
      {
        hide: (el, s) => s.activeIndex === 0,
        icon: 'arrow left',
        text: '{{ learn.coach.previous | polyglot }}',
        onClick: (ev, el, s) => {
          s.apply((_) => s.activeIndex--)
        }
      },
      {
        icon: 'sf question oval',
        text: '{{ common.action.learn_more | polyglot }}',
        onClick: (ev, el, s) => {
          const activeItem = s.slides[s.activeIndex]
          el.setWindow('docs', activeItem.docsArticle)
        }
      },
      {
        flow: 'row-reverse',
        isLast: (el, s) => el.key == s.activeIndex,
        icon: (el) => (el.isLast ? 'checkmark' : 'arrow right'),
        text: (el) =>
          el.call('polyglot', el.isLast ? 'learn.gifSlider.okay' : 'learn.gifSlider.next'),
        onClick: (ev, el, s) => {
          const activeItem = s.slides[s.activeIndex]
          if (activeItem.callback) el.call('exec', activeItem.callback)
          const isLast = el.isLast
          if (!isLast) {
            s.apply((_) => s.activeIndex++)
            return
          }
          el.lookup((el) => el.rootSlider).remove()
          el.call('setCookie', 'tutorialMarked_' + s.key, true)
        }
      }
    ]
  },
  flow: 'y',
  position: 'relative',
  gap: 'X',
  width: 'H2',
  rootSlider: true
}
